import React from "react";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";

const iconStyle = {
  cursor: "pointer"
};

/* Based on https://ant.design/components/form/#components-form-demo-customized-form-controls */
class Selector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null
    };
    this.callOnChange = this.callOnChange.bind(this);
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.value !== state.value) {
      return {
        value: nextProps.value
      };
    } else {
      return null;
    }
  }

  callOnChange(value) {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }

  render() {
    const {disabled, detailTitle, selectTitle, resetTitle, onDetail, onSelect, onReset, render, variant, sx} =
      this.props;

    const {value} = this.state;

    return (
      <TextField
        className="textfield-selector"
        value={render ? render(value) : value}
        onChange={f => f}
        variant={variant || "outlined"}
        InputProps={{
          readOnly: true,
          endAdornment: disabled ? undefined : value !== null ? (
            resetTitle ? (
              <Tooltip title={resetTitle}>
                <CloseIcon
                  className="textfield-selector__reset"
                  onClick={onReset}
                  style={iconStyle}
                  tabIndex="0"
                  onKeyDown={event => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      onReset();
                    }
                  }}
                />
              </Tooltip>
            ) : (
              <CloseIcon
                onClick={onReset}
                style={iconStyle}
                tabIndex="0"
                onKeyDown={event => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onReset();
                  }
                }}
              />
            )
          ) : selectTitle ? (
            <Tooltip title={selectTitle}>
              <AddIcon
                className="textfield-selector__select"
                onClick={onSelect}
                style={iconStyle}
                tabIndex="0"
                onKeyDown={event => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onSelect();
                  }
                }}
              />
            </Tooltip>
          ) : (
            <AddIcon
              className="textfield-selector__select"
              onClick={onSelect}
              style={iconStyle}
              tabIndex="0"
              onKeyDown={event => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onSelect();
                }
              }}
            />
          ),
          startAdornment:
            onDetail && value !== null ? (
              detailTitle ? (
                <Tooltip title={detailTitle}>
                  <VisibilityIcon onClick={onDetail} style={iconStyle} />
                </Tooltip>
              ) : (
                <VisibilityIcon onClick={onDetail} style={iconStyle} />
              )
            ) : undefined
        }}
        sx={sx}
        inputProps={{tabIndex: -1}}
      />
    );
  }
}

export default Selector;
